import { render } from "./BalanceGuessLivePage.vue?vue&type=template&id=430070ec"
import script from "./BalanceGuessLivePage.vue?vue&type=script&lang=js"
export * from "./BalanceGuessLivePage.vue?vue&type=script&lang=js"

import "./BalanceGuessLivePage.vue?vue&type=style&index=0&id=430070ec&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__